// Configuration
export const BASE_URL = 'https://app.hausboot-niederrhein.de/';
export const API_URL = `${BASE_URL}main.json`;
export const REDIRECT_DELAY = 1800000; // 30 Minutes
